import { PanelLeft, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { useAiChatPanel } from '@/hooks/aiChat/useAiChatPanel';

export const ChatPanelHeader = () => {
    const { historySidebarOpen, toggleHistorySidebar } = useAiChatPanel();
    const isDesktop = useIsDesktop();

    return (
        <SheetHeader className="flex-shrink-0 px-4 pt-0 pb-3 border-b light:border-gz-neutral-200 dark:border-gz-blue-500">
            <div className="flex items-center gap-2">
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={toggleHistorySidebar}
                    className="text-white light:text-foreground dark:text-foreground"
                    aria-label={historySidebarOpen ? 'Close sidebar' : 'Open sidebar'}
                    data-onboarding="sidebar-toggle"
                    data-track-click="AI Chat Sidebar Toggle Clicked"
                    data-track-location="ai-chat"
                    data-track-button-name="ai-chat-sidebar-toggle"
                >
                    {historySidebarOpen && isDesktop
                        ? <X className="size-5" />
                        : <PanelLeft className="size-5" />}
                </Button>
                <SheetTitle className="text-white light:text-foreground dark:text-foreground">ZigBot</SheetTitle>
            </div>
        </SheetHeader>
    );
};
